/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';

type Props = {
  /**
   * The children to put in the grid.
   */
  children: ComponentChildren;
};

/**
 * An empty list.
 */
export const EmptyList = ({ children }: Props) => {
  return (
    <div role="grid" aria-rowcount={0} tabIndex={0}>
      <div role="row">
        <div role="gridcell">{children}</div>
      </div>
    </div>
  );
};
